var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 -0.00195312C16.0238 -0.00195312 20.5016 4.47589 20.5016 9.9996C20.5016 15.5233 16.0238 20.0011 10.5001 20.0011C4.97638 20.0011 0.498535 15.5233 0.498535 9.9996C0.498535 4.47589 4.97638 -0.00195312 10.5001 -0.00195312ZM10.5001 1.49805C5.80481 1.49805 1.99854 5.30432 1.99854 9.9996C1.99854 14.6949 5.80481 18.5011 10.5001 18.5011C15.1954 18.5011 19.0016 14.6949 19.0016 9.9996C19.0016 5.30432 15.1954 1.49805 10.5001 1.49805ZM10.4964 8.4986C10.8761 8.4984 11.1901 8.7803 11.24 9.1464L11.2469 9.2481L11.2505 14.7497C11.2508 15.1639 10.9152 15.5 10.501 15.5002C10.1213 15.5005 9.80729 15.2185 9.75739 14.8525L9.75049 14.7507L9.74689 9.2491C9.74669 8.8349 10.0822 8.4989 10.4964 8.4986ZM10.5005 5.00086C11.0521 5.00086 11.4992 5.44798 11.4992 5.99953C11.4992 6.55107 11.0521 6.99819 10.5005 6.99819C9.94899 6.99819 9.50189 6.55107 9.50189 5.99953C9.50189 5.44798 9.94899 5.00086 10.5005 5.00086Z",
    fill: "#888B8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.9ac2d1fd46ed4dd0ba1532d60114d4fd.svg";
export { ForwardRef as ReactComponent };